import { RichText } from 'src/components/typo'
import css from './styles.module.scss'

const ComparatorsIntro = ({ label, title, subTitle }) => {
  return (
    <div className={css.container}>
      {label && <RichText className={css.label} text={label} />}
      {title && <RichText className={css.title} text={title} tag="h1" />}
      {subTitle && (
        <RichText className={css.subTitle} text={subTitle} tag="h2" />
      )}
    </div>
  )
}

export default ComparatorsIntro
